import styled, { css } from 'styled-components';

import Flex from '../Flex';

const getBackgroundColor = ({ theme, variant }) => {
  switch (variant) {
    case 'success':
      return theme.colors.semantic.status.success;
    case 'info':
      return theme.colors.semantic.status.info;
    case 'danger':
      return theme.colors.semantic.status.danger;
    case 'attention':
      return theme.colors.semantic.status.attention;
    case 'warning':
    default:
      return theme.colors.semantic.status.warning;
  }
};

const getAccentColor = ({ theme, variant }) => {
  switch (variant) {
    case 'success':
      return theme.colors.success500;
    case 'info':
      return theme.colors.info500;
    case 'danger':
      return theme.colors.danger500;
    case 'attention':
      return theme.colors.orange500;
    case 'warning':
    default:
      return theme.colors.warning500;
  }
};

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: ${getBackgroundColor};
  color: ${({ theme }) => theme.colors.semantic.text.primary};
  padding: 14px 16px;
  border-radius: 8px;
  border-left: 4px solid ${getAccentColor};

  svg {
    flex-shrink: 0;
  }
`;

export const Header = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const Body = styled(Flex)`
  flex-direction: column;
  ${({ expanded }) =>
    expanded
      ? css`
          margin-top: 8px;
          height: auto;
          opacity: 1;
        `
      : css`
          margin-top: 0;
          height: 0;
          opacity: 0;
        `};
  overflow: hidden;
  transition: all 0.2s ease-in-out;
`;
